import { CommonResponseCodes } from './gen/RequestResponseTypes';

// Based on bolt-server/src/delivery/provider/delivery_provider_portal/main/constants/ResponseCodes.ts
// and bolt-server/src/delivery/provider/delivery_provider/main/config/ResponseCodes.ts
export class ResponseCodes extends CommonResponseCodes {
  // DELIVERY PROVIDER PORTAL ERROR CODES
  public static readonly INVALID_PERMISSIONS = 5801;
  public static readonly INVALID_DATA = 5802;
  public static readonly PROVIDER_SHARD_NOT_FOUND = 5803;
  public static readonly REPORT_EXPORT_FAILED = 5804;
  public static readonly NOT_IMPLEMENTED = 100000;
  public static readonly TRAIT_NOT_FOUND = 5852;
  public static readonly DETAILED_REPORT_FAILED_TO_GENERATE_RETRYABLE = 5853;

  // DELIVERY PROVIDER ERROR CODES 5801-6000
  public static readonly REFRESH_TOKEN_INVALID = 210;
  public static readonly DATA_NOT_CACHED_YET = 2400;
  public static readonly PROVIDER_ACCOUNT_INVALID_CREDENTIALS = 5877;
  public static readonly PROVIDER_NOT_FOUND = 5810;
  public static readonly PROVIDER_LOCATION_NOT_FOUND = 5811;
  public static readonly CITY_NOT_FOUND = 5812;
  public static readonly CITY_ALREADY_CREATED = 5813;
  public static readonly DUPLICATE_USERNAME = 5814;
  public static readonly VENDOR_NOT_FOUND = 5815;
  public static readonly DELIVERY_NOT_AVAILABLE = 5816;
  public static readonly INVOICING_ACCOUNT_NOT_FOUND = 5817;
  public static readonly INVALID_SCHEDULE = 5818;
  public static readonly NOT_SUPPORTED = 5819;
  public static readonly NO_TAGS_FOUND = 5820;
  public static readonly PROVIDER_ACCOUNT_NOT_FOUND = 5822;
  public static readonly FAILED_TO_UPLOAD_PROVIDER_IMAGE = 5823;
  public static readonly FAILED_TO_PROCESS_IMAGE_TRANSFORMATIONS = 5824;
  public static readonly PROVIDER_IMAGES_NOT_FOUND = 5825;
  public static readonly PROVIDER_WITH_IMAGE_NOT_FOUND = 5828;
  public static readonly PROVIDER_HAS_NO_VALID_MENU = 5829;
  public static readonly TOO_MANY_PROVIDER_TAGS = 5830;
  public static readonly INVALID_PROVIDER_STATUS_TRANSITION = 5831;
  public static readonly CITY_AREA_NOT_FOUND = 5832;
  public static readonly OPS_ACCOUNT_NOT_FOUND = 5833;
  public static readonly MISSING_CITIES_FOR_OPS_ACCOUNT = 5834;
  public static readonly OVERLAPPING_SCHEDULE_INTERVALS = 5835;
  public static readonly PROVIDER_ATTEMPT_TRANSITION_TO_SAME_STATE = 5836;
  public static readonly MISSING_COMPANY_LEGAL_DETAILS = 5837;
  public static readonly BUSINESS_PROVIDER_HAS_NO_COMPANY_ASSOCIATED = 5838;
  public static readonly EMAIL_USED_FOR_ANOTHER_BUSINESS_PROVIDER = 5839;
  public static readonly FAILED_TO_UPDATE_COMPANY_OF_BUSINESS_PROVIDER = 5840;
  public static readonly MISSING_VAT_CODE = 5841;
  public static readonly PROVIDER_WITHOUT_NAME = 5843;
  public static readonly ACCOUNT_NOT_FOUND = 5845;
  public static readonly PASSWORD_RESET_INVALID_TOKEN = 5846;
  public static readonly PASSWORD_RESET_TOKEN_USED = 5847;
  public static readonly PASSWORD_RESET_TOKEN_EXPIRED = 5848;
  public static readonly CITY_PRICE_FORMATTING_SETTING_UNKNOWN = 5849;
  public static readonly CITY_PRICE_FORMATTING_SETTING_VALUE_UNKNOWN = 5850;
  public static readonly CITY_PRICE_FORMATTING_SETTING_MISSING = 5851;
  public static readonly EMPTY_WORKING_HOURS = 5853;
  public static readonly ACCOUNT_ALREADY_EXISTS_AND_ACCOUNT_PERMISSIONS_UPDATED = 5854;
  public static readonly CITY_PROVIDER_ROBOCALL_TRIGGER_UNKNOWN = 5855;
  public static readonly CITY_PROVIDER_ROBOCALL_INVALID_SETTING = 5856;
  public static readonly CAMPAIGN_ALREADY_IN_INTERVAL = 5857;
  public static readonly CAMPAIGN_REMOVED = 5858;
  public static readonly PROVIDER_CAN_NOT_ASSIGN_CAMPAIGNS = 5859;
  public static readonly CAMPAIGNS_SHARE_SLUG = 5860;
  public static readonly TRAIT_ALREADY_ADDED = 5861;
  public static readonly CAMPAIGN_LOG_ENTRY_NOT_FOUND = 5862;
  public static readonly CITY_MENU_SETTINGS_INVALID = 5863;
  public static readonly PROVIDER_TAG_NOT_FOUND = 5864;
  public static readonly PROVIDER_COMPANY_NOT_FOUND = 5865;
  public static readonly COUNTRY_NOT_FOUND = 5866;
  public static readonly MISSING_PROVIDER_STATUS_CHANGE_OPS_REASON = 5867;
  public static readonly INVALID_PROVIDER_STATUS_TRANSITION_ACTIVE_ORDERS = 5868;
  public static readonly WEB_FORM_AUTH_FLOW_FAILED = 5869;
  public static readonly DEPRECATED_PROVIDER_APP_VERSION = 5870;
  public static readonly DARK_KITCHEN_CREATE_TRAIT_FAILED = 5871;
  public static readonly DARK_KITCHEN_UPDATE_TRAIT_FAILED = 5872;
  public static readonly DARK_KITCHEN_GENERATE_CHEF_ACCOUNT_FAILED = 5873;
  public static readonly DARK_KITCHEN_ACCOUNT_NOT_FOUND = 5874;
  public static readonly DARK_KITCHEN_LOCATION_NOT_FOUND = 5875;
  public static readonly CANNOT_EXTRACT_PROVIDER_ID = 9004;
  public static readonly DARK_KITCHEN_NOT_FOUND = 5876;
  public static readonly BATCH_SIZE_TOO_LARGE = 5878;
  public static readonly EMPTY_COMMISSION_CHANGED_REASONS = 5879;
  public static readonly ENTITY_NOT_DAC7_LIABLE = 5880;
  public static readonly INVALID_PROVIDER_COMPANY_INFORMATION = 5881;
  public static readonly FAILED_TO_RETRIEVE_DATA_FOR_AVAILABILITY_PROXY = 5882;
  public static readonly INVALID_EMAIL_CONFIRMATION = 5883;
  public static readonly PROVIDER_DOCUMNET_NOT_VALID = 5884;
  public static readonly DUPLICATE_USERNAME_OR_EMAIL = 5885;
  public static readonly FORBIDDEN_ONBOARDING_DETAILS_CHANGE = 5886;
  public static readonly PROVIDER_ACCOUNT_LOCKED = 5887;
  public static readonly ACCOUNT_UNLOCK_INVALID_TOKEN = 5888;
  public static readonly ACCOUNT_UNLOCK_TOKEN_USED = 5889;
  public static readonly INVALID_ACCOUNT_UNLOCK_TOKEN = 5890;
}
